// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, section h1, .access-denied__status {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

:host {
  display: block;
  width: 100%;
  height: 100%;
}

.access-denied {
  display: flex;
  min-height: 100%;
  padding: 3rem 2rem;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #0b2d71;
}

section {
  width: min(100%, 38rem);
  text-align: center;
}
section h1 {
  margin: 0 0 1rem;
  font-size: 2rem;
  letter-spacing: 0;
}
section p {
  margin: 0.5rem 0;
  color: #6b6d6f;
  font-size: 1.125rem;
  line-height: 1.5;
}

.access-denied__status {
  color: #0066b2 !important;
  font-size: 0.875rem !important;
}

@media (max-width: 600px) {
  .access-denied {
    padding: 2rem 1.25rem;
  }
  section h1 {
    font-size: 1.65rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/app/pages/unauthorized-page/unauthorized-page.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ACCT;ADUA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ACOT;ADWA;EACE,4CAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,8CAAA;ACTF;;ADaA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ACVF;;ADaA;EACE,mBA5CO;EA6CP,OAAA;ACVF;;ADaA;EACE,mBAhDM;EAiDN,OAAA;ACVF;;ADaA;EACE,eApDO;EAqDP,OAAA;ACVF;;ADaA;EACE,mBAxDO;EAyDP,OAAA;ACVF;;ADaA;EACE,kBA5DM;EA6DN,OAAA;ACVF;;AAtDA;EACC,cAAA;EACA,WAAA;EACA,YAAA;AAyDD;;AAtDA;EACC,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,cChBW;ADyEZ;;AAtDA;EACC,uBAAA;EACA,kBAAA;AAyDD;AAvDC;EAEC,gBAAA;EACA,eAAA;EACA,iBAAA;AAwDF;AArDC;EACC,gBAAA;EACA,cCZU;EDaV,mBD9BM;EC+BN,gBAAA;AAuDF;;AAlDA;EAEC,yBAAA;EACA,8BAAA;AAoDD;;AAjDA;EACC;IACC,qBAAA;EAoDA;EAhDA;IACC,kBAAA;EAkDD;AACF","sourcesContent":["// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","@use '../../../styles/colors.scss' as colors;\n@use '../../../styles/fonts.scss' as fonts;\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.access-denied {\n\tdisplay: flex;\n\tmin-height: 100%;\n\tpadding: 3rem 2rem;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: transparent;\n\tcolor: colors.$dark-blue;\n}\n\nsection {\n\twidth: min(100%, 38rem);\n\ttext-align: center;\n\n\th1 {\n\t\t@extend .cvx-font-gotham-bold;\n\t\tmargin: 0 0 1rem;\n\t\tfont-size: 2rem;\n\t\tletter-spacing: 0;\n\t}\n\n\tp {\n\t\tmargin: 0.5rem 0;\n\t\tcolor: colors.$dark-gray;\n\t\tfont-size: fonts.$large;\n\t\tline-height: 1.5;\n\t}\n\n}\n\n.access-denied__status {\n\t@extend .cvx-font-gotham-bold;\n\tcolor: colors.$medium-blue !important;\n\tfont-size: fonts.$medium !important;\n}\n\n@media (max-width: 600px) {\n\t.access-denied {\n\t\tpadding: 2rem 1.25rem;\n\t}\n\n\tsection {\n\t\th1 {\n\t\t\tfont-size: 1.65rem;\n\t\t}\n\t}\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
